//
import { mapActions, mapState } from 'vuex'
import {
  RForm,
  ModelDataTable,
  VBtnAction,
} from '@/components/reusable_components/next'
import { RequiredRule } from '@/mixins/reusable_mixins/rules'

//
import PurchaseOrderModel from '@/models/Purchase/PchPurchaseOrder'
import filters from './filters'
import headers from './headers'

//
export default {
  name: 'purchase-order-list',
  components: {
    RForm,
    ModelDataTable,
    VBtnAction,
  },
  computed: {
    /**
     * 
     */
    removeProps() {
      return {
        fields: [
          {
            name: 'reject_provider_comment',
            type: 'textarea',
            flex: {
              xs12: true,
            },
            props: {
              label: 'Comentario',
              rules: [RequiredRule],
            },
          }
        ]
      }
    },
    /**
     *
     */
    tableProps() {
      return {
        service: PurchaseOrderModel,
        filters,
        headers,
        paramFilter: {
          pch_purchase_order_state_id: [1, 3].join(','), // el estado 2 es de rechazada, por lo tanto no debe ir en la lista
        },
      }
    },
    //
    ...mapState('SnackbarModalModule', {
      responseConfirm: 'responseConfirm',
    }),
  },
  data() {
    return {
      dialogs: {
        remove: false,
      },
      selected: null,
    }
  },
  methods: {
    //
    ...mapActions('MenuesModule', {
      setTitleTopBar: 'setTitleTopBar',
    }),
    //
    ...mapActions('SnackbarModalModule', {
      setErrorSnackbar: 'setErrorSnackbar',
      setSuccessSnackbar: 'setSuccessSnackbar',
      setWarningSnackbar: 'setWarningSnackbar',
    }),
    applyRemove() {
      return this
        .toWaitRemove(true)
        .then(this.remove)
        .then(this.toWaitRemove)
    },
    /**
     *
     */
    authorize() {
      return this
        .selected
        .authorize()
        .attach()
        .then(this.successAuthorize)
        .then(this.refresh)
        .catch(this.errorAuthorize)
    },
    /**
     *
     */
    errorAuthorize() {
      this.setErrorSnackbar('No se puede autorizar la orden de compra.')
    },
    /**
     *
     */
    errorRemove() {
      this.setErrorSnackbar('No se puede eliminar la orden de compra.')
    },
    /**
     *
     */
    errorReject() {
      this.setErrorSnackbar('No se puede rechazar la orden de compra.')
    },
    /**
     *
     */
    errorSent() {
      this.setErrorSnackbar('No se puede enviar la orden de compra.')
    },
    /**
     *
     */
    refresh() {
      this.$refs.table.refresh()
    },
    /**
     *
     */
    reject() {
      return this
        .selected
        .reject()
        .attach()
        .then(this.successReject)
        .then(this.refresh)
        .catch(this.errorReject)
    },
    /**
     *
     */
    remove() {
      return this
        .selected
        .delete()
        .then(this.successRemove)
        .then(this.refresh)
        .catch(this.errorRemove)
    },
    /**
     *
     */
    sent() {
      return this
        .selected
        .sent()
        .attach()
        .then(this.successSent)
        .then(this.refresh)
        .catch(this.errorSent)
    },
    /**
     *
     */
    submitAuthorize(event) {
      //
      this.selected = event.item
      //
      this.setWarningSnackbar({
        title: 'Autorizar',
        message: '¿Confirma la autorización de la orden de compra?',
        confirm: 'autorizar',
      })
    },
    /**
     *
     */
    submitReject(event) {
      //
      this.selected = event.item
      //
      this.setWarningSnackbar({
        title: 'Rechazar',
        message: '¿Confirma el rechazo de la orden de compra?',
        confirm: 'rechazar',
      })
    },
    /**
     *
     */
    submitRemove(event) {
      //
      this.selected = event.item
      //
      /*this.setWarningSnackbar({
        title: 'Eliminar',
        message: '¿Confirma la eliminación de la orden de compra?',
        confirm: 'eliminar',
      })*/
      //
      this.dialogs.remove = true
    },
    /**
     *
     */
    submitSent(event) {
      //
      this.selected = event.item
      //
      this.setWarningSnackbar({
        title: 'Enviar',
        message: '¿Confirma el envió de la orden de compra?',
        confirm: 'enviar',
      })
    },
    /**
     *
     */
    submitUpdate(event) {
      this.$router.push({
        name: 'purchase-order-update',
        query: {
          from: 'purchase-order-pending',
        },
        params: {
          id: event.item.id,
        },
      })
    },
    /**
     *
     */
    successAuthorize() {
      this.setSuccessSnackbar('Orden de compra autorizada exitosamente.')
    },
    /**
     *
     */
    successReject() {
      this.setSuccessSnackbar('Orden de compra rechazada exitosamente.')
    },
    /**
     *
     */
    successRemove() {
      this.setSuccessSnackbar('Orden de compra eliminada exitosamente.')
      this.dialogs.remove = false
    },
    /**
     *
     */
    successSent() {
      this.setSuccessSnackbar('Orden de compra enviada exitosamente.')
    },
    /**
     * 
     */
    toWaitRemove(value=false) {
      return this
        .$refs
        .remove
        .setWait(value)
    }
  },
  watch: {
    responseConfirm(val) {
      switch (val) {
        case 'autorizar': return this.authorize()
        case 'eliminar' : return this.remove()
        case 'rechazar' : return this.reject()
        case 'enviar'   : return this.sent()
      }
    },
  },
  beforeMount() {
    this.setTitle('Órdenes de compra pendientes')
  },
  beforeRouteEnter(to, from, next) {
    next(ctx => {
      if (!ctx.$can('VIEW_ALL_PURCHASE_ORDER')) ctx.$router.push('/')
    })
  },
}
